import { z } from 'zod';

import type { CreateContactInquiryRequest } from '@mds/shared/types/contact';
import { ONE_LINE, email, isOneLine, required, tooLong } from '@mds/shared/lib/validation';

/** Mirrors `createContactInquirySchema` in the API's contact module. */
export const contactSchema = z.object({
  fullName: required('Full name').max(160, tooLong(160)),
  email,
  subject: required('Subject').max(120, tooLong(120)).refine(isOneLine, ONE_LINE),
  message: required('Message').max(1000, tooLong(1000)),
}) satisfies z.ZodType<CreateContactInquiryRequest>;

export type ContactForm = z.input<typeof contactSchema>;
